import { Operation } from '../../../__generated__/globalTypes'

import {
  InviteFragment,
  inviteFragmentString,
} from '../../fragments/__generated__/InviteFragment'

import { socProContactFragmentString } from '../../fragments/__generated__/SocProContactFragment'

import { prospectFragmentString } from '../../fragments/__generated__/ProspectFragment'

import { addressFragmentString } from '../../fragments/__generated__/AddressFragment'

import getPaginatedInvitesRawString from '../GetPaginatedInvites.graphql'

const getPaginatedInvitesString = [
  getPaginatedInvitesRawString,
  inviteFragmentString,
  socProContactFragmentString,
  prospectFragmentString,
  addressFragmentString,
].join('\n\n')

export type GetPaginatedInvitesData = {
  paginatedInvites: {
    results: InviteFragment[]
    count: number
  }
}

export type GetPaginatedInvitesVariables = {
  offset: number
  limit: number
}

export type GetPaginatedInvites = Operation<
  GetPaginatedInvitesData,
  GetPaginatedInvitesVariables
>

export const GetPaginatedInvites = ({
  offset,
  limit,
}: GetPaginatedInvitesVariables): GetPaginatedInvites => ({
  query: getPaginatedInvitesString,
  variables: {
    offset,
    limit,
  },
})
